import { parseResponse } from "api/resources/handlers/parseResponse/parseResponse";

import axios from "axios";
import { GET_TCU_AVAILABLE_SLOTS } from "api/resources/configs/URL";
import { getRequestOptions } from "api/resources/configs/requests";
import { GetTcuAvailableSlotsPayload } from "./getTcuAvailableSlot.fromApi.types";
import { formatGetTcuAvailableSlotErrorMessage } from "api/resources/messages/ErrorMessage";

const getTcuAvailableSlots = async (
  memberIdentifier: string | null,
  institutionCode: string,
  regInstitutionCode: string,
): Promise<GetTcuAvailableSlotsPayload> => {
  try {
    const response = await axios.post<GetTcuAvailableSlotsPayload>(
      GET_TCU_AVAILABLE_SLOTS(),
      {
        MemberIdentifier: memberIdentifier,
        InstitutionCode: institutionCode,
        RegInstitutionCode: regInstitutionCode,
      },
      getRequestOptions(),
    );
    return parseResponse(response, GET_TCU_AVAILABLE_SLOTS());
  } catch (error) {
    const msg = formatGetTcuAvailableSlotErrorMessage(
      GET_TCU_AVAILABLE_SLOTS(),
    );
    console.error(msg);
    throw error;
  }
};

export { getTcuAvailableSlots };
